import tw from 'tailwind-styled-components'

export const ContentWrapper = tw.div`
  text-white p-5
`
export const UserInfoWrapper = tw.div`
    flex items-center justify-start gap-20 p-10 my-20
`

export const UserInfoRight = tw.div`
    flex flex-col
`

export const UserName = tw.p`
    whitespace-nowrap font-black text-xl
`

export const UserTier = tw.p`
  text-darkGrey text-xs font-semibold mb-5
`

export const EliteChipWrapper = tw.h5`
  whitespace-nowrap
`